import { useCallback, useState } from "react";
import { getBackendUrl } from "../../../../../../util/envFn";
import axios from "axios";
import { Workspace } from "../../../../types/types";
import { API_PREFIX_WORKSPACES } from "../../constants";

const useWorkspace_Server = () => {
    const createWorkspace = async (): Promise<Workspace> => {
        const response = await axios.post(getBackendUrl(API_PREFIX_WORKSPACES));
        refresh();
        return response.data;
    };

    const getWorkspaces = useCallback(async (): Promise<Workspace[]> => {
        const response = await axios.get(getBackendUrl(API_PREFIX_WORKSPACES));
        return response.data;
    }, []);

    const updateWorkspace = async (workspaceId: string, updates: Partial<Workspace>): Promise<Workspace> => {
        const response = await axios.put(getBackendUrl(`${API_PREFIX_WORKSPACES}/${workspaceId}`), updates);
        refresh();
        return response.data;
    };

    const deleteWorkspace = async (workspaceId: string): Promise<boolean> => {
        const response = await axios.delete(getBackendUrl(`${API_PREFIX_WORKSPACES}/${workspaceId}`));
        refresh();
        return !!response.data;
    };

    const [workspaces, setWorkspaces] = useState<Workspace[]>([]);
    const [workspaceMap, setWorkspaceMap] = useState<Map<string, Workspace>>(new Map());

    const refresh = useCallback(async () => {
        try {
            const workspaces = await getWorkspaces();
            setWorkspaces(workspaces);
            setWorkspaceMap(new Map(workspaces.map(w => [w.id, w])));
        } catch (error) {
            // console.error("Error refreshing workspaces:");
        }
    }, [getWorkspaces]);

    const clear = useCallback(async () => {
        setWorkspaces([]);
        setWorkspaceMap(new Map());
    }, []);

    return {
        refresh,
        clear,
        workspaces,
        workspaceMap,
        createWorkspace,
        updateWorkspace,
        deleteWorkspace,
    }
}

export default useWorkspace_Server;